import {Component, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import {LoaderService, NavigateService} from 'ngx-satoris';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from 'src/app/shared/services/api.service';
import {Currency, OperationType, PrintReceiptData, RequestCashType} from 'src/app/shared/models/request';
import {DocumentType} from 'src/app/shared/models/user';
import {CartService} from 'src/app/shared/services/cart.service';
import {QrService} from 'src/app/shared/services/qr.service';
import {ScanDocumentService} from '../../../shared/services/scan-document.service';

@Component({
  selector: 'app-admin-request-face-check',
  templateUrl: './admin-request-face-check.component.html',
  styleUrls: ['./admin-request-face-check.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminRequestFaceCheckComponent implements OnInit{

  optionsCamera = {
    x: 0,
    y: 0,
    width: window.screen.width,
    height: window.innerHeight,
    camera: 'front',
    toBack: false,
    tapFocus: true,
    previewDrag: false,
    storeToFile: false,
    disableExifHeaderStripping: true
  };

  picture: string;
  imageQuality = 1;
  showCamera = false;
  backParams = {};
  backSelect = {};
  noticePrintData = {};
  DocumentType = DocumentType;
  query: {
    createdAt: string,
    paymentId: string,
    placeID: string,
    userPlaceID: string,
    operation: OperationType,
    from: string,
    paymentReference: string,
    cashType: RequestCashType,
    amount: string,
    currency: Currency,
    fromScanPassport: boolean,
    fromScanFingerprint: string,
    localUsageUntil: Date,
    fromNoticePrint: string,
    buyDocument: DocumentType,
    nameClient: string,
    paymentIsNotDocument: 'Yes' | 'No',
    borderPass: string,
  };
  currentPrintReceiptDatas: PrintReceiptData;

  closePreview: EventEmitter<any> = new EventEmitter<any>();
  showFaceCheck: boolean;
  faceCheckScore: number = 0;
  faceCheckScoreColor: string;
  scoreInterval: any;

  constructor(public nav: NavigateService,
    public scanDocument: ScanDocumentService,
    private loader: LoaderService,
    private route: ActivatedRoute,
    private api: ApiService,
    private cart: CartService,
    private qr: QrService) {
    this.route.queryParams.subscribe((params: any) => {
      const {createdAt, paymentId, placeID, userPlaceID, operation, from, paymentReference, provisionalPermit, localUsageUntil, occupationMedia, fromScanPassport, fromScanFingerprint, fromNoticePrint, cashType, referencePrint, datePrint, nameClient, amount, currency, agentId, typePayment, placeId, buyDocument, idRequest, paymentIsNotDocument, borderPass, ...rest} = params;
      this.query = {createdAt, paymentId, placeID, userPlaceID, operation, occupationMedia, provisionalPermit, localUsageUntil, from, paymentReference, fromScanPassport, fromNoticePrint, cashType, fromScanFingerprint, referencePrint, datePrint, nameClient, amount, currency, agentId, typePayment, placeId, buyDocument, idRequest, paymentIsNotDocument,  borderPass, ...rest};
      this.backSelect = {from: this.query.from, ...rest};
      this.backParams = (fromScanFingerprint === 'true' || fromNoticePrint === 'true') ? params : this.backSelect;
    });
  }

  ngOnInit(): void {
    this.loader.loading(true);
    setTimeout(() => {
      this.loader.loading(false);
      this.showCamera = true;
    }, 1500);
  }

  setPicture(imageUrl: string) {
    this.picture = imageUrl;
  }


  close() {
    this.picture = '';
    this.faceCheckScoreColor = undefined;
    this.faceCheckScore = 0;
    this.showFaceCheck = false;
  }

  faceCheck() {
    clearInterval(this.scoreInterval);
    this.loader.loading(true);
    this.api.facialCheck(this.picture.split(',')[1], this.scanDocument.documentPhoto.split(',')[1]).then((res) => {
      const score = res * 100;
      this.loader.loading(false);
      this.showFaceCheck = true;
      this.scoreInterval = setInterval(() => {
        if(this.faceCheckScore < score) {
          this.faceCheckScore++;
          //color goes from red to green as the score goes up between 0 and 100
          this.faceCheckScoreColor = 'rgb(' + (255 - (this.faceCheckScore * 2.2)) + ', ' + (this.faceCheckScore * 2.2) + ', 0)';
        }
      }, 1000 / score);
    }).catch(() => {
      this.loader.loading(true, {type: 'error', message: 'error.faceCheck'});
    });
  }

  consumePayment(cameraManualProblem = false, cameraProblem = false) {
    this.nav.to('admin-request-face-check', undefined, {queryParams: {
      paymentId: this.query.paymentId,
      userPlaceID: this.query.userPlaceID,
      placeID: this.query.placeID,
      createdAt: new Date(this.query.createdAt),
      operation: this.query.operation,
      cashType: this.query.cashType,
      amount: this.query.amount,
      currency: this.query.currency,
      borderPass: this.query.borderPass,
      localUsageUntil: this.query.localUsageUntil,
      nameClient: this.query.nameClient,
      buyDocument: this.query.buyDocument,
      paymentIsNotDocument: this.query.paymentIsNotDocument,
      ...this.backParams,
      fromScanPassport: this.query.fromScanPassport,
      fromScanFingerprint: this.query.fromScanFingerprint,
      fromNoticePrint: this.query.fromNoticePrint,
      paymentReference: this.query.paymentReference
    }});
    this.loader.loading(true, {type: cameraProblem? 'warn' : 'info', message: cameraProblem ? 'camera.init.error' : cameraManualProblem ? 'camera.problem.manual' : ('payment.consume.ask.DYN.' + this.api.env.type), btnLabel: 'global.confirm'}).then((done) =>{
      if(done) {
        this.loader.loading(true);
        if(this.query.fromScanFingerprint !== 'true') {
          window.sessionStorage.removeItem('fingerprint');
        }
        if(this.query.fromNoticePrint !== 'true') {
          window.sessionStorage.removeItem('noticePrint');
        }
        const fingerPrintData = window.sessionStorage.getItem('fingerprint') ? window.sessionStorage.getItem('fingerprint') : undefined;
        this.noticePrintData = window.sessionStorage.getItem('noticePrint') ? JSON.parse(window.sessionStorage.getItem('noticePrint')) : undefined;
        return this.cart.editSyncQueue({
          agentId: this.api.userInfo.id,
          paymentId: this.query.paymentId,
          consumedPlaceId: this.query.userPlaceID,
          createdPlaceId: this.query.placeID,
          createdAt: new Date(this.query.createdAt),
          localUsageUntil: this.query.localUsageUntil,
          consumeMessage: '',
          consumeData:
          {
            ProfilePicture: this.picture,
            Operation: this.query.operation,
            PaymentReference: this.query.paymentReference,
            PaymentIsNotDocument: this.query.paymentIsNotDocument,
            PaymentMode: this.query.cashType,
            PaymentAmountCents: this.query.paymentIsNotDocument === 'Yes' ? +this.query.amount : undefined,
            PaymentCurrency: this.query.currency,
            Fingerprint: fingerPrintData ? JSON.parse(fingerPrintData) : undefined,
            ...this.noticePrintData
          }
        }).then(() => {
          window.sessionStorage.removeItem('fingerprint');
          window.sessionStorage.removeItem('noticePrint');
          this.cart.callSyncQueue().then(() => {
            if(this.query?.paymentReference && this.query?.cashType && this.query?.currency) {
              return this.askPrint();
            } else {
              this.loader.loading(true, {type: 'valid', message: 'payment.consume.done.DYN.' + this.api.env.type}).then(() => {
                if(this.query.fromScanPassport) {
                  this.nav.to(this.query.from);
                } else {
                  this.nav.to('admin-request-select/' + this.query.paymentId, undefined, {queryParams: this.backSelect});
                }
              });
            }
          });
        }).catch(() => {
          this.loader.loading(true, {type: 'error', message: 'payment.consume.error.DYN.' + this.api.env.type});
        });
      } else {
        if(cameraProblem) {
          if(this.query.fromScanPassport) {
            this.nav.to(this.query.from);
          } else {
            this.nav.to('admin-request-select/' + this.query.paymentId, undefined, {queryParams: {from: this.query.from}});
          }
        }
      }
    });
  }

  askPrint() {
    return this.loader.loading(true, {type: 'info', message: 'payment.consume.print.done.DYN.' + this.api.env.type}).then(() => {
      this.doPrint().then(() => this.loader.loading(true, {type: 'info', message: 'payment.ask.print', btnLabel: 'global.yes', custom: {closeBtnLabel: 'global.no.retry'}}).then((done) => {
        if(done) {
          if(this.query.fromScanPassport) {
            return this.nav.to(this.query.from);
          } else {
            this.nav.to('admin-request-select/' + this.query.paymentId, undefined, {queryParams: this.backSelect});
          }
        } else {
          return this.askPrint();
        }
      }).catch(() => {
        this.loader.loading(true, {type: 'error', message: 'error.printReceipt'});
      }));
    });
  }


  doPrint = () => new Promise<void>((resolve) => {
    this.currentPrintReceiptDatas = {
      referencePrint: this.query.paymentReference,
      datePrint: new Date(),
      nameClient: this.query.nameClient,
      amount: +this.query.amount,
      currency: this.query.currency,
      agentId: this.api.userInfo.id + '',
      typePayment: this.query.cashType,
      placeId: this.api.userPlaceId,
      buyDocument: (this.query.borderPass && this.query.borderPass === 'Yes') ? DocumentType.BORDER_PASS : this.query.buyDocument,
      idRequest: this.query.paymentId,
      operation: this.query.operation
    };
    this.qr.qrOfflineGenerate(this.api.userPlaceId, this.query.paymentId, undefined);
    setTimeout(() => {
      window.print();
      this.currentPrintReceiptDatas = null;
      resolve();
    });
  });

  goBack() {
    if(this.query.fromNoticePrint === 'true') {
      this.nav.to('admin-request-notice/' + this.query.paymentId, undefined, {queryParams: this.backParams});
    } else if(this.query.fromScanFingerprint === 'true') {
      this.nav.to('admin-scan-fingerprint');
    } else if(this.query.from && this.query.fromScanPassport) {
      this.nav.to(this.query.from, undefined, {queryParams: this.backParams});
    } else {
      this.nav.to('admin-request-select/' + this.query.paymentId, undefined, {queryParams: this.backParams});
    }
  }
}
